import { Params } from '@angular/router';

export function pageIndexFromParams(params: Params, pageParamName = 'p'): number {
  const pageParam = Number(params?.[pageParamName] ?? 0);

  if (!isNaN(pageParam)) {
    return Math.trunc(pageParam);
  }

  return 0;
}
